/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Channelmessagelabel2Inputs */

const en_channelmessagelabel2 = /** @type {(inputs: Channelmessagelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Message`)
};

const de_channelmessagelabel2 = /** @type {(inputs: Channelmessagelabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nachricht`)
};

/**
* | output |
* | --- |
* | "Message" |
*
* @param {Channelmessagelabel2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const channelmessagelabel2 = /** @type {((inputs?: Channelmessagelabel2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Channelmessagelabel2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_channelmessagelabel2(inputs)
	return de_channelmessagelabel2(inputs)
});
export { channelmessagelabel2 as "channelMessageLabel" }